export default {
  splash: {
    title: 'BatiKal',
    descr: "L'assistant de vos choix énergétiques",
    signupLabel: 'Rejoindre',
    signinLabel: 'Se connecter'
  }
}
